<mat-form-field>
  <mat-select
    panelClass="custom-overlay-select"
    [(ngModel)]="selectedOption"
    [id]="uniqueId"
    [disabled]="disabled"
    [placeholder]="placeholder"
  >
    <mat-select-trigger *ngIf="selectedOption">
      <span>{{ selectedOption.text || selectedOption.label }}</span>
    </mat-select-trigger>
    <mat-option
      *ngFor="let option of options"
      [value]="option"
      (onSelectionChange)="selectOption(option, $event)"
      [class.mat-option-description]="option.description"
    >
      <span [ngClass]="optionTextLayout">
        <span class="option-text" [class.capitalize]="capitalizeOptionText">{{
          option.text || option.label
        }}</span>
        <span *ngIf="option.description" class="option-description">{{ option.description }}</span>
      </span>
    </mat-option>
  </mat-select>
</mat-form-field>
